export var CardPaymentMerchantEnum;
(function (CardPaymentMerchantEnum) {
    CardPaymentMerchantEnum["BOG"] = "BOG";
    CardPaymentMerchantEnum["FLITT"] = "FLITT";
})(CardPaymentMerchantEnum || (CardPaymentMerchantEnum = {}));
//# sourceMappingURL=card-payment-merchant.enum.js.map